import PropTypes from 'prop-types';

import {
  useCaptureException
} from '@zenbusiness/application-commons-logging';
import { PriceListProvider } from '@zenbusiness/application-commons-pricelist';

/*
 * Provide a wrapper such that we have access to the logging context
 * in the providers file
 */
export default function PriceListWrapper({ priceListUuid, children }) {
  const captureError = useCaptureException();
  return (
    <PriceListProvider priceListUuid={priceListUuid} onError={captureError}>
      {children}
    </PriceListProvider>
  );
}

PriceListWrapper.propTypes = {
  priceListUuid: PropTypes.string
};
